import "./ArchiveProductTemplate.module.css"
import MainNavigation from "@/reusable_sections/Header"
import ArchiveTitleSection from "./sections/ArchiveTitleSection"
import ShopContent from "./sections/ShopContent"
import Footer from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <MainNavigation />
      <ArchiveTitleSection />
      <ShopContent />
      <Footer />
    </div>
  )
}
